import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import Spinner from "components/common/Spinner";

const UnauthRoute = ({ children }) => {
    const { isLoggedIn, authChecked } = useAuth();
    const location = useLocation();

    if (!authChecked) {
        return <Spinner />; // 🔄 Pendant vérification
    }

    if (isLoggedIn) {
        return <Navigate to="/accès-interdit" replace state={{ from: location.pathname }} />;
    }

    return children;
};

export default UnauthRoute;
